import * as moment from "moment";
import { round, TIMEOUT } from "src/global";
import fs from "src/services/config/fbConfig";
import { IAnnualSummaryByMonthRow } from "./interfaces";

export function generateSingleRateSummaryByMonth(
  projectId: string
): Promise<IAnnualSummaryByMonthRow[]> {
  return new Promise<IAnnualSummaryByMonthRow[]>(resolve => {
    const rows: IAnnualSummaryByMonthRow[] = [];
    const projectDocument = fs.fs.collection("projects").doc(projectId);
    const simpleStatements = projectDocument.collection("simpleSingleRateStatements");
    let checkEstimate: boolean;
    projectDocument
      .get()
      .then(projDoc => {
        if (projDoc.exists) {
          const { checkEstimatedGeneration } = projDoc.data() as any;
          if (checkEstimatedGeneration === undefined) {
            checkEstimate = false;
          } else {
            checkEstimate = true;
          }
        }
      })
      .then(() => {
        projectDocument
          .collection("statements")
          .orderBy("statementDate")
          .get()
          .then(querySnapshot => {
            const promises: any[] = [];
            querySnapshot.forEach(doc => {
              if (doc.exists) {
                const {
                  statementDate,
                  totalAmountDue,
                  serviceStartDate,
                  serviceEndDate,
                  yearsWithSolar,
                } = doc.data() as any;
                const numberOfDays = round(
                  moment.duration(moment(serviceEndDate).diff(moment(serviceStartDate))).asDays(),
                  0
                );
                promises.push(
                  simpleStatements
                    .doc(doc.id)
                    .get()
                    .then(simpleDoc => {
                      if (simpleDoc.exists) {
                        let { gridUsage, solarGenerated, solarUsage } = simpleDoc.data() as any;
                        if (!gridUsage) {
                          gridUsage = 0;
                        }
                        if (!solarGenerated) {
                          solarGenerated = 0;
                        }
                        if (!solarUsage) {
                          solarUsage = 0;
                        }
                        const meetsEstimate: boolean = false;
                        let avagEstimatedPower: number = 0;
                        let payment: number = 0;
                        let bPayment: number = 0;
                        projectDocument
                          .collection("guaranteedPowerTable")
                          .where("productionAnniversary", "==", yearsWithSolar)
                          .get()
                          .then(querySnapshot => {
                            if (querySnapshot.size === 1) {
                              const {
                                averageEstimatedPower,
                                leasePayment,
                                budgetPayment,
                              } = querySnapshot.docs[0].data() as any;
                              avagEstimatedPower = averageEstimatedPower
                                ? averageEstimatedPower
                                : 0;
                              payment = leasePayment ? leasePayment : 0;
                              bPayment = budgetPayment ? budgetPayment : 0;
                              checkEstimate = true;
                            } else {
                              checkEstimate = false;
                            }
                          })
                          .then(() => {
                            let savings: number = 0;
                            const totalCost: number = totalAmountDue + payment;
                            if (avagEstimatedPower > 0 && payment > 0 && bPayment) {
                              savings = bPayment - totalCost;
                            }
                            const percentSolarGenerated =
                              (solarGenerated / (gridUsage + (solarGenerated - solarUsage))) *
                              100.0;

                            setTimeout(() => {
                              rows.push({
                                id: doc.id,
                                statementDate: statementDate ? statementDate : Date.now(),
                                serviceStart: serviceStartDate ? serviceStartDate : Date.now(),
                                serviceEnd: serviceEndDate ? serviceEndDate : Date.now(),
                                numberOfDays,
                                totalDelivered: gridUsage,
                                totalSolarGenerated: solarGenerated,
                                metEstimatedGeneration: meetsEstimate,
                                checkEstimate,
                                avagEstimatedPower,
                                totalSolarRecived: solarUsage,
                                netGridUsage:
                                  gridUsage - solarUsage < 0 ? 0 : gridUsage - solarUsage,
                                solarDirectlyUsed: solarGenerated - solarUsage,
                                totalHouseholdUsage: gridUsage + (solarGenerated - solarUsage),
                                percentSolarGenerated,
                                leasePayment: round(payment, 2),
                                electricBillAmount: round(totalAmountDue, 2),
                                totalCost: round(totalCost, 2),
                                budgetPayment: round(bPayment, 2),
                                electricitySavings: round(savings, 2),
                              });
                            }, TIMEOUT);
                          });
                      }
                    })
                );
              }
            });
            Promise.all(promises).then(() => {
              resolve(rows);
            });
          });
      });
  });
}



// WEBPACK FOOTER //
// ./src/pages/projects/project/reports/SingleRateSummaryByMonth.tsx